import { Context, Controller } from '@hotwired/stimulus';
import { toggleHidden } from 'src/utils/dom-toggle';

export default class TemplatesRoleRequirementsController extends Controller {
  public static targets = [
    'roleInput',
    'isRoleRequirementWarning',
    'wasRoleRequirementWarning',
  ];

  declare roleInputTargets: HTMLInputElement[];
  declare isRoleRequirementWarningTarget: HTMLElement;
  declare wasRoleRequirementWarningTarget: HTMLElement;

  private initialRoleRequired: Record<string, boolean>;

  public constructor(context: Context) {
    super(context);

    this.onChange = this.onChange.bind(this);
    this.initialRoleRequired = {};
  }

  disconnect(): void {
    super.disconnect();

    this.initialRoleRequired = {};
  }

  roleInputTargetConnected(element: HTMLElement) {
    element.addEventListener('change', this.onChange);

    const checked = (element as HTMLInputElement).checked;
    const role = (element as HTMLInputElement).value;

    if (role) {
      this.initialRoleRequired[role] = checked;
    }
  }

  roleInputTargetDisconnected(element: HTMLElement) {
    element.removeEventListener('change', this.onChange);

    const role = (element as HTMLInputElement).value;

    if (role) {
      delete this.initialRoleRequired[role];
    }
  }

  private get addedRoleRequired(): boolean {
    let anyAdded = false;

    this.roleInputTargets.forEach((element) => {
      anyAdded ||= element.checked && !this.initialRoleRequired[element.value];
    });

    return anyAdded;
  }

  private get removedRoleRequired(): boolean {
    let anyRemoved = false;

    this.roleInputTargets.forEach((element) => {
      anyRemoved ||=
        !element.checked && this.initialRoleRequired[element.value];
    });

    return anyRemoved;
  }

  private onChange(_event: Event) {
    const isRoleRequired = this.addedRoleRequired;
    const wasRoleRequired = this.removedRoleRequired;

    toggleHidden(this.isRoleRequirementWarningTarget, !isRoleRequired);
    toggleHidden(this.wasRoleRequirementWarningTarget, !wasRoleRequired);

    this.isRoleRequirementWarningTarget
      .querySelectorAll<HTMLInputElement | HTMLTextAreaElement>(
        'input, textarea',
      )
      .forEach((element) => {
        element.required = isRoleRequired;
        element.readOnly = !isRoleRequired;
      });

    this.wasRoleRequirementWarningTarget
      .querySelectorAll<HTMLInputElement | HTMLTextAreaElement>(
        'input, textarea',
      )
      .forEach((element) => {
        element.required = wasRoleRequired;
        element.readOnly = !wasRoleRequired;
      });
  }
}
